import styled, { css, keyframes } from 'styled-components';
import progressBarBackgroundColor from 'common/ProgressBarBackgroundColor';

const IndicatorAnimation = $theme => keyframes`
  0% {
    width: 0%;
    transform: translateX(0%);
    background-color: ${$theme.progressInitialColor};
  }
  65% {
    width: 50%;
    background-color: rgb(${progressBarBackgroundColor(65, $theme)});
    transform: translateX(150%);
  }
  75% {
    width: 50%;
    background-color: rgb(${progressBarBackgroundColor(75, $theme)});
    transform: translateX(200%);
  }
  100% {
    width: 50%;
    background-color: ${$theme.progressFinalColor};
    transform: translateX(200%);
  }
`;

const barStyle = css`
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  transition: transform 0.5s linear;
  transform-origin: left;
`;

export default {
  Wrapper: styled.div`
    min-width: 100%;
    ${({ $theme }) => css`background: ${$theme.track};`}
    position: relative;
    overflow: hidden;
    ${props => props.thickness === 'min' ? css`height: 0.125rem;` : css`height: 0.25rem;`}
    ${({ rtl }) => rtl && css`
      transform: scale(-1, 1);
    `}
  `,
  SlowIndicator: styled.div`
    ${barStyle}
    ${({ $theme }) => css`
      animation: ${IndicatorAnimation($theme)} 2.1s cubic-bezier(0.4, 0, 1, 1);
    `}
  `,
  FastIndicator: styled.div`
    ${barStyle}
    ${({ $theme }) => css`
      animation: ${IndicatorAnimation($theme)} 1.5s cubic-bezier(0.4, 0, 1, 1);
    `}
  `,
  IndicatorWrapper: styled.div`
    width: 100%;
  `,
  Indicator: styled.div`
    ${barStyle}
    transition: none;
    ${({ $theme }) => css`
      background-color: ${$theme.progressInitialColor};
    `}
`
};